import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { AppContext } from "../context/useAppContext";

function Search() {
  const [searchFilter, setSearchFilter] = useState("");
  const [appState, setAppState] = useContext(AppContext);
  // FILTER RENDER ICONS WITH SEARCH PARAMS
  useEffect(() => {
    if (searchFilter !== "") {
      const filtered = appState.icons.filter((icon) =>
        icon.name.toLowerCase().includes(searchFilter.toLowerCase())
      );

      setAppState((appState) => ({
        ...appState,
        selectedCategory: "All Icons",
        selectedCategoryIcons: filtered,
      }));
    } else {
      setAppState((appState) => ({
        ...appState,
        selectedCategory: "All Icons",
        selectedCategoryIcons: appState.icons,
      }));
    }
     // eslint-disable-next-line
  }, [searchFilter]);

  useEffect(() => {
    setSearchFilter("");
  }, []);
  return (
    <input
      type="text"
      id="email-adress-icon"
      className="block p-2 pl-10 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 sm:text-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
      placeholder="Search..."
      value={searchFilter}
      onChange={(event) => setSearchFilter(event.target.value)}
    />
  );
}

export default Search;
